import { Box, Button, Flex, Menu, MenuButton, MenuItemOption, MenuList, MenuOptionGroup, Stack, Wrap, WrapItem } from '@chakra-ui/react';
import ButtonLink from '~/components/ButtonLink';
import Hero from '~/components/Hero';
import HeroSearchForm from '~/components/Hero/SearchForm/SearchForm';
import HtmlParser from '~/components/HtmlParser/HtmlParser';
import Image from '~/components/Image';
import Layout from '~/components/Layout';
import ProgramThumbnail from '~/components/ProgramThumbnail';
import SectionWithTitle from '~/components/SectionWithTitle';
import SEO from '~/components/SEO';
import useCurrentBreakpointIndex from '~/hooks/useCurrentBreakpointIndex';
import { getCurrentOrigin } from '~/utils/getCurrentDomain';
import { getSeoDataFromWordpressForPage } from '~/utils/getSeoData';
import { createImageWithArtDirection } from '~/utils/imageUtils';
import React, { useEffect, useState } from 'react';

var FormuleTemplate = function FormuleTemplate(props) {
  var _data$allWpProgramme$, _contentTypeData$lang, _contentTypeData$lang2, _contentTypeData$acfF, _contentTypeData$acfF2, _contentTypeData$acfF3, _contentTypeData$acfF4, _contentTypeData$acfF5, _contentTypeData$acfF6, _contentTypeData$acfF7, _contentTypeData$acfF8, _contentTypeData$acfF9, _contentTypeData$acfF10, _pageTemplateData$acf, _pageTemplateData$acf2, _pageTemplateData$acf3, _pageTemplateData$acf4, _pageTemplateData$acf5, _pageTemplateData$acf6, _pageTemplateData$acf7, _contentTypeData$acfF11, _contentTypeData$acfF12, _pageTemplateData$acf8, _pageTemplateData$acf9, _contentTypeData$acfF13, _contentTypeData$acfF14, _contentTypeData$acfF15, _contentTypeData$acfF16, _contentTypeData$acfF17, _contentTypeData$acfF18, _contentTypeData$acfF19, _contentTypeData$acfF20, _sceanceOnline;

  var data = props.data;
  var pageContext = props.pageContext;
  var contentTypeData = data.wpFormule;
  var pageTemplateData = data.wpPageTemplate;
  var programs = (_data$allWpProgramme$ = data.allWpProgramme.nodes) === null || _data$allWpProgramme$ === void 0 ? void 0 : _data$allWpProgramme$.filter(function (program) {
    var _program$acfProgram, _program$acfProgram$a, _program$acfProgram$a2;

    return program === null || program === void 0 ? void 0 : (_program$acfProgram = program.acfProgram) === null || _program$acfProgram === void 0 ? void 0 : (_program$acfProgram$a = _program$acfProgram.attributes) === null || _program$acfProgram$a === void 0 ? void 0 : (_program$acfProgram$a2 = _program$acfProgram$a.formule) === null || _program$acfProgram$a2 === void 0 ? void 0 : _program$acfProgram$a2.some(function (formule) {
      return (formule === null || formule === void 0 ? void 0 : formule.id) === (contentTypeData === null || contentTypeData === void 0 ? void 0 : contentTypeData.id);
    });
  });

  var _useState = useState(programs),
      filteredPrograms = _useState[0],
      setFilteredPrograms = _useState[1];

  var _useState2 = useState(undefined),
      programClassTypeFilter = _useState2[0],
      setProgramClassTypeFilter = _useState2[1];

  useEffect(function () {
    if (!programClassTypeFilter) return setFilteredPrograms(programs);
    var programsFilteredByFormule = programs.filter(function (program) {
      var _program$acfProgram2, _program$acfProgram2$;

      var classTypeCriteria = program === null || program === void 0 ? void 0 : (_program$acfProgram2 = program.acfProgram) === null || _program$acfProgram2 === void 0 ? void 0 : (_program$acfProgram2$ = _program$acfProgram2.attributes) === null || _program$acfProgram2$ === void 0 ? void 0 : _program$acfProgram2$.languageClassCategory.includes(programClassTypeFilter);
      return classTypeCriteria;
    });
    setFilteredPrograms(programsFilteredByFormule);
  }, [programClassTypeFilter]);
  if (!contentTypeData || !(contentTypeData !== null && contentTypeData !== void 0 && contentTypeData.link) || !((_contentTypeData$lang = contentTypeData.language) !== null && _contentTypeData$lang !== void 0 && _contentTypeData$lang.slug) || !pageContext.defaultLanguage) return null;
  var seoProps = getSeoDataFromWordpressForPage({
    availableTranslations: contentTypeData.translations,
    currentLanguage: (_contentTypeData$lang2 = contentTypeData.language) === null || _contentTypeData$lang2 === void 0 ? void 0 : _contentTypeData$lang2.locale,
    currentOrigin: getCurrentOrigin(),
    defaultLanguage: pageContext.defaultLanguage,
    featuredImageUrl: (_contentTypeData$acfF = contentTypeData.acfFormule) === null || _contentTypeData$acfF === void 0 ? void 0 : (_contentTypeData$acfF2 = _contentTypeData$acfF.informations) === null || _contentTypeData$acfF2 === void 0 ? void 0 : (_contentTypeData$acfF3 = _contentTypeData$acfF2.desktopFeaturedImage) === null || _contentTypeData$acfF3 === void 0 ? void 0 : (_contentTypeData$acfF4 = _contentTypeData$acfF3.localFile) === null || _contentTypeData$acfF4 === void 0 ? void 0 : (_contentTypeData$acfF5 = _contentTypeData$acfF4.childImageSharp) === null || _contentTypeData$acfF5 === void 0 ? void 0 : (_contentTypeData$acfF6 = _contentTypeData$acfF5.gatsbyImageData) === null || _contentTypeData$acfF6 === void 0 ? void 0 : _contentTypeData$acfF6.src,
    pagePath: props.location.pathname,
    pageSlug: contentTypeData.slug,
    seo: contentTypeData.seo
  });
  var imageWithArtDirection = createImageWithArtDirection({
    desktopImage: (_contentTypeData$acfF7 = contentTypeData.acfFormule) === null || _contentTypeData$acfF7 === void 0 ? void 0 : (_contentTypeData$acfF8 = _contentTypeData$acfF7.informations) === null || _contentTypeData$acfF8 === void 0 ? void 0 : _contentTypeData$acfF8.desktopFeaturedImage,
    mobileImage: (_contentTypeData$acfF9 = contentTypeData.acfFormule) === null || _contentTypeData$acfF9 === void 0 ? void 0 : (_contentTypeData$acfF10 = _contentTypeData$acfF9.informations) === null || _contentTypeData$acfF10 === void 0 ? void 0 : _contentTypeData$acfF10.mobileFeaturedImage
  });
  var heroForm = /*#__PURE__*/React.createElement(HeroSearchForm, {
    displayedFields: pageTemplateData === null || pageTemplateData === void 0 ? void 0 : (_pageTemplateData$acf = pageTemplateData.acfFormuleTemplate) === null || _pageTemplateData$acf === void 0 ? void 0 : (_pageTemplateData$acf2 = _pageTemplateData$acf.formuleHeroSection) === null || _pageTemplateData$acf2 === void 0 ? void 0 : _pageTemplateData$acf2.searchFormFields,
    formule: contentTypeData.slug
  });
  var introductionSection = /*#__PURE__*/React.createElement(SectionWithTitle, {
    heading: pageTemplateData === null || pageTemplateData === void 0 ? void 0 : (_pageTemplateData$acf3 = pageTemplateData.acfFormuleTemplate) === null || _pageTemplateData$acf3 === void 0 ? void 0 : (_pageTemplateData$acf4 = _pageTemplateData$acf3.formuleIntroductionSection) === null || _pageTemplateData$acf4 === void 0 ? void 0 : _pageTemplateData$acf4.title
  }, /*#__PURE__*/React.createElement(Stack, {
    direction: "row",
    align: "center",
    justify: "center",
    mt: 4
  }, pageTemplateData === null || pageTemplateData === void 0 ? void 0 : (_pageTemplateData$acf5 = pageTemplateData.acfFormuleTemplate) === null || _pageTemplateData$acf5 === void 0 ? void 0 : (_pageTemplateData$acf6 = _pageTemplateData$acf5.zoomSection) === null || _pageTemplateData$acf6 === void 0 ? void 0 : (_pageTemplateData$acf7 = _pageTemplateData$acf6.ctas) === null || _pageTemplateData$acf7 === void 0 ? void 0 : _pageTemplateData$acf7.map(function (cta) {
    var _cta$cta;

    return /*#__PURE__*/React.createElement(ButtonLink, {
      key: cta === null || cta === void 0 ? void 0 : (_cta$cta = cta.cta) === null || _cta$cta === void 0 ? void 0 : _cta$cta.label,
      cta: cta === null || cta === void 0 ? void 0 : cta.cta
    });
  })), /*#__PURE__*/React.createElement(HtmlParser, {
    textBlock: true
  }, contentTypeData === null || contentTypeData === void 0 ? void 0 : (_contentTypeData$acfF11 = contentTypeData.acfFormule) === null || _contentTypeData$acfF11 === void 0 ? void 0 : (_contentTypeData$acfF12 = _contentTypeData$acfF11.informations) === null || _contentTypeData$acfF12 === void 0 ? void 0 : _contentTypeData$acfF12.introductionText));
  var programsSection = /*#__PURE__*/React.createElement(SectionWithTitle, {
    heading: pageTemplateData === null || pageTemplateData === void 0 ? void 0 : (_pageTemplateData$acf8 = pageTemplateData.acfFormuleTemplate) === null || _pageTemplateData$acf8 === void 0 ? void 0 : (_pageTemplateData$acf9 = _pageTemplateData$acf8.formuleProgramsSection) === null || _pageTemplateData$acf9 === void 0 ? void 0 : _pageTemplateData$acf9.title,
    headerFontColor: "white",
    _after: {
      bg: 'secondary.500',
      content: '""',
      height: '100%',
      left: '50%',
      maxWidth: '450px',
      position: 'absolute',
      top: 0,
      transform: 'translateX(-50%)',
      width: '100%',
      zIndex: 'hide'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      visibility: contentTypeData.slug === 'cours-de-langue' ? 'visible' : 'hidden'
    },
    zIndex: 20
  }, /*#__PURE__*/React.createElement(Menu, {
    closeOnSelect: false
  }, /*#__PURE__*/React.createElement(MenuButton, {
    as: Button,
    bg: "primary.100",
    fontSize: 14,
    color: "secondary.500"
  }, "Type de cours"), /*#__PURE__*/React.createElement(MenuList, {
    minWidth: "240px"
  }, /*#__PURE__*/React.createElement(MenuOptionGroup, {
    onChange: setProgramClassTypeFilter,
    type: "radio"
  }, /*#__PURE__*/React.createElement(MenuItemOption, {
    value: "junior"
  }, "Junior"), /*#__PURE__*/React.createElement(MenuItemOption, {
    value: "student"
  }, "\xC9tudiant"), /*#__PURE__*/React.createElement(MenuItemOption, {
    value: "adult"
  }, "Adulte"), /*#__PURE__*/React.createElement(MenuItemOption, {
    value: "professional"
  }, "Professionnel"))))), /*#__PURE__*/React.createElement(Wrap, {
    justify: "center",
    spacing: 8,
    w: "100%"
  }, filteredPrograms.map(function (program, index) {
    var _program$acfProgram3, _program$acfProgram3$, _program$acfProgram$i, _program$acfProgram4, _program$acfProgram4$, _program$acfProgram5, _program$acfProgram5$, _program$acfProgram6, _program$acfProgram6$, _program$acfProgram6$2, _program$acfProgram6$3, _program$acfProgram7, _program$acfProgram7$, _program$acfProgram7$2, _program$acfProgram7$3, _program$acfProgram7$4, _program$acfProgram7$5;

    return /*#__PURE__*/React.createElement(WrapItem, {
      key: program === null || program === void 0 ? void 0 : program.uri
    }, /*#__PURE__*/React.createElement(ProgramThumbnail, {
      bg: index % 2 === 0 ? 'primary.500' : 'primary.100',
      description: program === null || program === void 0 ? void 0 : (_program$acfProgram3 = program.acfProgram) === null || _program$acfProgram3 === void 0 ? void 0 : (_program$acfProgram3$ = _program$acfProgram3.introduction) === null || _program$acfProgram3$ === void 0 ? void 0 : _program$acfProgram3$.shortIntroduction,
      image: (_program$acfProgram$i = program === null || program === void 0 ? void 0 : (_program$acfProgram4 = program.acfProgram) === null || _program$acfProgram4 === void 0 ? void 0 : (_program$acfProgram4$ = _program$acfProgram4.introduction) === null || _program$acfProgram4$ === void 0 ? void 0 : _program$acfProgram4$.thumbnail) !== null && _program$acfProgram$i !== void 0 ? _program$acfProgram$i : program === null || program === void 0 ? void 0 : (_program$acfProgram5 = program.acfProgram) === null || _program$acfProgram5 === void 0 ? void 0 : (_program$acfProgram5$ = _program$acfProgram5.heroProgram) === null || _program$acfProgram5$ === void 0 ? void 0 : _program$acfProgram5$.mobileFeaturedImage,
      city: program === null || program === void 0 ? void 0 : (_program$acfProgram6 = program.acfProgram) === null || _program$acfProgram6 === void 0 ? void 0 : (_program$acfProgram6$ = _program$acfProgram6.introduction) === null || _program$acfProgram6$ === void 0 ? void 0 : (_program$acfProgram6$2 = _program$acfProgram6$.cityName) === null || _program$acfProgram6$2 === void 0 ? void 0 : (_program$acfProgram6$3 = _program$acfProgram6$2[0]) === null || _program$acfProgram6$3 === void 0 ? void 0 : _program$acfProgram6$3.title,
      country: program === null || program === void 0 ? void 0 : (_program$acfProgram7 = program.acfProgram) === null || _program$acfProgram7 === void 0 ? void 0 : (_program$acfProgram7$ = _program$acfProgram7.attributes) === null || _program$acfProgram7$ === void 0 ? void 0 : (_program$acfProgram7$2 = _program$acfProgram7$.country) === null || _program$acfProgram7$2 === void 0 ? void 0 : (_program$acfProgram7$3 = _program$acfProgram7$2[0]) === null || _program$acfProgram7$3 === void 0 ? void 0 : (_program$acfProgram7$4 = _program$acfProgram7$3.acfDestination) === null || _program$acfProgram7$4 === void 0 ? void 0 : (_program$acfProgram7$5 = _program$acfProgram7$4.heroDestination) === null || _program$acfProgram7$5 === void 0 ? void 0 : _program$acfProgram7$5.destinationName,
      uri: program === null || program === void 0 ? void 0 : program.uri
    }));
  })));
  var currentBreakpoint = useCurrentBreakpointIndex();
  var zoomSection = /*#__PURE__*/React.createElement(SectionWithTitle, {
    heading: contentTypeData === null || contentTypeData === void 0 ? void 0 : (_contentTypeData$acfF13 = contentTypeData.acfFormule) === null || _contentTypeData$acfF13 === void 0 ? void 0 : (_contentTypeData$acfF14 = _contentTypeData$acfF13.zoom) === null || _contentTypeData$acfF14 === void 0 ? void 0 : _contentTypeData$acfF14.title
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: {
      base: 'column',
      lg: 'row'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    bg: "secondary.500",
    p: {
      base: 4,
      lg: 12
    },
    flex: 1
  }, /*#__PURE__*/React.createElement(HtmlParser, {
    order: {
      base: 1,
      lg: 0
    },
    color: "white",
    fontWeight: 400,
    textBlock: true
  }, contentTypeData === null || contentTypeData === void 0 ? void 0 : (_contentTypeData$acfF15 = contentTypeData.acfFormule) === null || _contentTypeData$acfF15 === void 0 ? void 0 : (_contentTypeData$acfF16 = _contentTypeData$acfF15.zoom) === null || _contentTypeData$acfF16 === void 0 ? void 0 : _contentTypeData$acfF16.text)), /*#__PURE__*/React.createElement(Stack, {
    spacing: 4,
    order: {
      base: 0,
      lg: 1
    },
    flex: 1
  }, currentBreakpoint > 0 && /*#__PURE__*/React.createElement(Image, {
    image: contentTypeData === null || contentTypeData === void 0 ? void 0 : (_contentTypeData$acfF17 = contentTypeData.acfFormule) === null || _contentTypeData$acfF17 === void 0 ? void 0 : (_contentTypeData$acfF18 = _contentTypeData$acfF17.zoom) === null || _contentTypeData$acfF18 === void 0 ? void 0 : _contentTypeData$acfF18.image,
    ratio: 1
  }))));
  return /*#__PURE__*/React.createElement(Layout, {
    currentLanguage: contentTypeData.language,
    currentPath: contentTypeData.link,
    menuData: pageContext.menus,
    siteSettings: pageContext.siteSettings,
    translations: contentTypeData.translations
  }, /*#__PURE__*/React.createElement(SEO, seoProps), /*#__PURE__*/React.createElement(Hero, {
    backgroundImage: imageWithArtDirection,
    couleurTitre: "#000",
    form: heroForm,
    heading: (_contentTypeData$acfF19 = contentTypeData.acfFormule) === null || _contentTypeData$acfF19 === void 0 ? void 0 : (_contentTypeData$acfF20 = _contentTypeData$acfF19.informations) === null || _contentTypeData$acfF20 === void 0 ? void 0 : _contentTypeData$acfF20.title
  }), introductionSection, zoomSection, (_sceanceOnline = contentTypeData.acfFormule.sceanceOnline) !== null && _sceanceOnline !== void 0 && _sceanceOnline.link ? /*#__PURE__*/React.createElement(SectionWithTitle, {
    heading: "S\xE9ances en ligne",
    direction: {
      base: 'column',
      md: 'row'
    },
    justify: "center",
    bg: "secondary.500",
    my: "0 !important"
  }, /*#__PURE__*/React.createElement(ButtonLink, {
    cta: {
      label: contentTypeData.acfFormule.sceanceOnline.link.title,
      externalLink: {
        url: contentTypeData.acfFormule.sceanceOnline.link.url,
        target: contentTypeData.acfFormule.sceanceOnline.link.target
      }
    }
  })) : null, programsSection);
};

export default FormuleTemplate;
var query = "3909002884";